import React from "react";
import ProductPreview from "../productPreview/index.js";

export const columns = [
  {
    key: "productName",
    name: "Product Name",
    sortable: true,
    resizable: true,
    sortDescendingFirst: true,
  },
  {
    key: "brand",
    name: "Brand",
    sortable: true,
    resizable: true,
  },
  {
    key: "website",
    name: "Website",
    sortable: true,
    resizable: true,
  },
  {
    key: "productId",
    name: "Product ID",
    sortable: true,
    resizable: true,
  },
  {
    key: "status",
    name: "Status",
    sortable: true,
    resizable: true,
    width: 150,
  },
  {
    key: `previewLink`,
    name: " ",
    width: 100,
    resizable: true,
    formatter: <ProductPreview />,
  },
];
